/**
 * Store utilities for managing store slug
 */

/**
 * Get store slug from URL or localStorage
 */
export const getStoreSlug = () => {
  // First, try to get from URL
  const urlParams = new URLSearchParams(window.location.search);
  const storeFromUrl = urlParams.get('store');
  
  if (storeFromUrl) {
    // Save to localStorage for future use
    localStorage.setItem('current_store', storeFromUrl);
    return storeFromUrl;
  }
  
  // If not in URL, try localStorage
  const storeFromStorage = localStorage.getItem('current_store');
  if (storeFromStorage) {
    return storeFromStorage;
  }
  
  // Default fallback
  return 'default';
};

/**
 * Set store slug in localStorage and update URL
 */
export const setStoreSlug = (storeSlug) => {
  localStorage.setItem('current_store', storeSlug);
  
  // Update URL without reload
  const url = new URL(window.location);
  url.searchParams.set('store', storeSlug);
  window.history.replaceState({}, '', url);
};

/**
 * Get store URL for sharing
 */
export const getStoreUrl = (storeSlug) => {
  const baseUrl = window.location.origin;
  return `${baseUrl}?store=${storeSlug}`;
};

/**
 * Get admin panel URL for a store
 */
export const getAdminUrl = (storeSlug) => {
  // This should be configured based on your admin panel URL
  const adminBaseUrl = import.meta.env.VITE_ADMIN_BASE_URL || 'https://admin.storeiq.shop';
  return `${adminBaseUrl}?store=${storeSlug}`;
};

